import './accessibility-helper'

import 'angular'

import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/src/tab'

import './on-scroll'
import './top-drawer'
import './menu'
import './home-slider'
// import './instagram'
import './checkout-collapse-shipping'
import './fancybox'
// import './popup-covid'
import './popup-newsletter'
import './dropdowns'
import './product-slider'
import './cookies'
import 'simplebar'

import {
    viewportSize
} from './imports/utils';

// ng-Shop
import './eshop/app'

var uiApp = angular.module("app", ["eshopApp"]);

uiApp.run(["$rootScope", "$window", function ($rootScope, $window) {
    if (viewportSize().width <= 991) {
        $rootScope.isMobile = true;
    } else {
        $rootScope.isMobile = false;
    }

    angular.element($window).bind('resize', function () {
        if (viewportSize().width <= 991) {
            $rootScope.isMobile = true;
        } else {
            $rootScope.isMobile = false;
        }
        $rootScope.$apply()
    });
}]);

uiApp.controller('AboutController', ['$scope', function ($scope) {

    $scope.enTexts = true;

    $scope.translate = function () {
        $scope.enTexts = !$scope.enTexts;
    }
}]);

uiApp.controller('BlogController', ['$scope', '$http', function ($scope, $http) {
    $scope.paginated = {};
    $scope.loadMore = function () {
        $http({
            method: "GET",
            url: window.location.pathname + '?ajax=1&page=' + ($scope.paginated.current_page + 1),
        }).then(function success(response) {
            var data = response.data;
            var current_data = $scope.paginated.data;
            $scope.paginated = data;
            $scope.paginated.data = current_data.concat(data.data);
            $scope.alterGETparam('page', $scope.paginated.current_page);
        }, function error(response) {
            var data = response.data;
        });
    }

    $scope.getUrlParameter = function (sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    }

    $scope.alterGETparam = function (key, value) {

        var url = window.location.href;
        var parser = document.createElement('a');
        parser.href = url;

        var newUrl = parser.protocol + '//' + parser.host + parser.pathname;
        // has parameters ?
        if (parser.search && parser.search.indexOf('?') !== -1) {
            // parameter already exists
            if (parser.search.indexOf(key + '=') !== -1) {
                // paramters to array
                var params = parser.search.replace('?', '');
                params = params.split('&');
                params.forEach(function (param, i) {
                    if (param.indexOf(key + '=') !== -1) {
                        if (value !== null) params[i] = key + '=' + value;
                        else delete params[i];
                    }
                });
                if (params.length > 0) newUrl += '?' + params.join('&');
            } else if (value !== null) newUrl += parser.search + '&' + key + '=' + value; // append new parameter
            else newUrl += parser.search; // skip the value (remove)
        } else if (value !== null) newUrl += '?' + key + '=' + value; // no parameters, create it

        newUrl += parser.hash;
        if (newUrl[newUrl.length - 1] == '&') {
            newUrl = newUrl.substring(0, newUrl.length - 1);
        }
        window.history.replaceState('', '', newUrl);

    }
}]);

uiApp.controller('TermsController', ['$scope', function ($scope) {
    $scope.enTexts = true;
    $scope.translate = function () {
        $scope.enTexts = !$scope.enTexts;
    }
}]);

$("[data-bg-src]").each(function () {
    var imgUrl = $(this).data("bg-src");
    $(this).css({
        "background-image": "url(" + imgUrl + ")"
    });
})

$("[data-scroll-to]").each(function () {
    $(this).click(function () {
        $("html, body").animate({
            scrollTop: 0
        }, "slow");
    });
});